export default {
    data() {
        return {
        }
    },
    methods: {
    }
}